import React from 'react';
export function Footer() {
  return <footer className="py-8 px-6 border-t" style={{
    backgroundColor: 'var(--bg-dark)',
    borderColor: 'rgba(247,245,240,0.1)'
  }} data-id="element-19">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" data-id="element-20">
        <img src="https://cdn.magicpatterns.com/uploads/k9FqYSBkvUsYyBue8z7vuu/abcd_logo.png" alt="abc design" className="h-7 w-auto" style={{
        filter: 'brightness(0) invert(1) opacity(0.6)'
      }} data-id="element-21" />
        <p style={{
        color: 'rgba(247,245,240,0.35)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-body)'
      }} data-id="element-22">
          © 2025 abc design. All rights reserved.
        </p>
        <a href="https://calendly.com/danielle-abc/30min" target="_blank" rel="noopener noreferrer" className="transition-colors duration-200 hover:opacity-100" style={{
        color: 'rgba(247,245,240,0.55)',
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--text-body)'
      }} data-id="element-23">
          Book now
        </a>
      </div>
    </footer>;
}